import React from 'react';
import Hero from '../components/Hero';
import Clients from '../components/Clients';
import Services from '../components/Services';
import CaseStudies from '../components/CaseStudies';
import Contact from '../components/Contact';

export default function Home() {
  return (
    <main>
      <Hero />
      <Clients />
      <Services />
      <CaseStudies />
      <Contact />
    </main>
  );
}
